import{ 
  Component,
  Input,
  ElementRef,
  Inject,
  OnInit,
  trigger, transition, state, style, animate, keyframes
   } 
   from '@angular/core';

import { APP_CONFIG } from './app.setting';import { HttpApiService } from './services/http.api';
import { ConfigurateurInit, ConfigurateurGroupe } from "app/model/configurateur";
import { swiper } from "swiper";
import { AppConfig } from "app/export.interfaces";

import { ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  animations: [
    trigger('fadeInOut', [
      transition('splash', [   // :enter is alias to 'void => *'
        style({opacity:0}),
        animate(500, style({opacity:1})) 
      ]),
      transition('config', [   // :leave is alias to '* => void'
        animate(500, style({opacity:0})) 
      ])
    ])
  ]
})
export class AppComponent implements OnInit {
  moduleId:string;
  title = 'app works! ';
  showInit:boolean = true;
  state:string = "splash";
  selectedGroupe:ConfigurateurGroupe;
  version:string = "no from qs !";

  constructor(@Inject(APP_CONFIG) config: AppConfig, private activatedRoute: ActivatedRoute) {
    }
     ngOnInit(){ 

      this.activatedRoute.queryParams.subscribe((params:Params) => {
          console.log('version: ' + params['version']);
          this.version = params['version'];
      });
      
    }

  onCancelConfiguration() {
    this.selectedGroupe = null;
    this.showInit = true;
  }

  onSelectGroupe(groupe: ConfigurateurGroupe) {
     console.log('groupe : ' + groupe);
    this.showInit = false;
    this.selectedGroupe = groupe;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts